export default "__VITE_ASSET__c154ef3f__"